module.exports = __webpack_public_path__ + "img/ani_jiant_b.dee4d2b7.png";